<script>
import Card from './Card';

export default {

    name: 'CardBody',

    extends: Card

};
</script>
